export const apiConstants = {
  AllClubs: 'Club/AllClubs',
  GetClub: 'Calculator/GetClub',
};
